// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Armenia */
const AM = /^(?:(?:33|4[1349]|55|77|88|9[13-9])\d{6})$/;

export default AM;
